import { ArticleResolution, FeatureRequestResolutions } from '@wix/answers-api';
import { Box, Tag, Text, Tooltip } from '@wix/design-system';
import { useTranslation } from '@wix/wix-i18n-config';
import React, { FC } from 'react';

import { HelpCenterArticle } from '../../types';
import s from './styles.scss';

export interface ResolutionTagProps {
  article: HelpCenterArticle;
}

export const statusToClass: Record<FeatureRequestResolutions, string> = {
  [ArticleResolution.COLLECTING_VOTES]: s.collectingVotes,
  [ArticleResolution.PLANNED]: s.planned,
  [ArticleResolution.IN_DEVELOPMENT]: s.inDev,
  [ArticleResolution.COMING_SOON]: s.preLaunch,
  [ArticleResolution.PENDING_RELEASE]: s.pendingRelease,
  [ArticleResolution.RELEASED]: s.released,
};

export const ResolutionStatusTag: FC<ResolutionTagProps> = ({ article }) => {
  const { t } = useTranslation();
  const { resolution } = article;

  if (!resolution) {
    return null;
  }

  return (
    <Box>
      <Tooltip size="small" content={t(`article_resolution_tooltip_${article.resolution}`)}>
        <Tag
          size="small"
          className={`${s.statusTag} ${statusToClass[resolution]}`}
          id={`${article.resolution}`}
          theme="warning"
          removable={false}
        >
          <Text size="small">{t(`article_resolution_${resolution}`)}</Text>
        </Tag>
      </Tooltip>
    </Box>
  );
};
